import { render, staticRenderFns } from "./DoudianMoveConfigPage.vue?vue&type=template&id=daceb4ca&scoped=true"
import script from "./DoudianMoveConfigPage.vue?vue&type=script&lang=js"
export * from "./DoudianMoveConfigPage.vue?vue&type=script&lang=js"
import style0 from "./DoudianMoveConfigPage.vue?vue&type=style&index=0&id=daceb4ca&prod&scoped=true&lang=css"
import style1 from "./DoudianMoveConfigPage.vue?vue&type=style&index=1&id=daceb4ca&prod&scoped=true&lang=css"
import style2 from "./DoudianMoveConfigPage.vue?vue&type=style&index=2&id=daceb4ca&prod&scoped=true&lang=css"
import style3 from "./DoudianMoveConfigPage.vue?vue&type=style&index=3&id=daceb4ca&prod&scoped=true&lang=css"
import style4 from "./DoudianMoveConfigPage.vue?vue&type=style&index=4&id=daceb4ca&prod&scoped=true&lang=css"
import style5 from "./DoudianMoveConfigPage.vue?vue&type=style&index=5&id=daceb4ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_cache-loader@4.1.0_webpack@4.47.0_supports-_28b733ef3ef89602fda58894ac543489/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daceb4ca",
  null
  
)

export default component.exports